import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button/Button';
import EmptyTaskManagement from 'components/EmptyTaskManagement/EmptyTaskManagement';
import Modal from 'components/Modal/Modal';
import StatusDropButton from 'components/StatusDropButton/StatusDropButton';
import Tabs from 'components/Tabs/Tabs';
import { TASK_HEAD_IRO_CELLS } from 'constants/dataSets';
import { STATUS } from 'constants/formFields';
import { BUTTON_VARIANT } from 'constants/interfaces';

import ItemsTable from '../ItemsTable/ItemsTable';

import type ISelectedItemModal from './interfaces/ISelectedItemModal';

import styles from './scss/SelectedItemModal.module.scss';

function SelectedItemModal({
  open,
  title,
  loading,
  handleCancel,
  handleAddSubmit,
  handleCreateCustomItem,
  control,
  hasMore,
  loadingItems,
  onLoadMore,
  naceCodeTreeData,
  items,
  onSelectItem,
  handleUnSelectAll,
  selectedItems,
  standards,
  activeStandard,
  handleActiveStandard,
  titleButton,
  tabName,
}: ISelectedItemModal) {
  const { t } = useTranslation();

  const handleGetOptions = () => Object.values(naceCodeTreeData.data).map((item) => (item.label));

  return (
    <Modal
      open={open}
      title={title || ''}
      className={styles.modalContainer}
      isButtonsVisible={false}
      showLoader={loading}
    >
      <div className={styles.root}>
        <div className={styles.content}>
          <div className={styles.headerWrapper}>
            <Controller
              control={control}
              name={STATUS}
              render={({ field: { value, onChange } }) => (
                <StatusDropButton
                  options={handleGetOptions()}
                  title={t('taskManagement.status')}
                  selectedOptions={value?.filter((item): item is string => item !== undefined)}
                  onSelectionChange={onChange}
                  clearAllSelected={() => onChange([])}
                  hideSearch
                />
              )}
            />
            <Button
              title={titleButton || t('materialityAssessment.buttonTitle2')}
              onClick={handleCreateCustomItem}
              className={styles.button}
            />
          </div>
          <Tabs
            data={standards}
            activeTab={activeStandard}
            onClickTab={handleActiveStandard}
          />
          <div className={styles.tableWrapper}>
            {items && items.length > 0 ? (
              <ItemsTable
                items={items}
                headCells={TASK_HEAD_IRO_CELLS}
                onLoadMore={onLoadMore}
                hasMore={hasMore}
                isLoadingMore={loadingItems}
                naceCodeTreeData={naceCodeTreeData}
                control={control}
                onSelectItem={onSelectItem}
                selectedItems={selectedItems}
                handleUnSelectAll={handleUnSelectAll}
                isInfoTable
              />
            ) : (
              <EmptyTaskManagement
                title={t('materialityAssessment.emptyTable', {
                  name: tabName,
                })}
                checkIcon
              />
            )}
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.cancel')}
            variant={BUTTON_VARIANT.cancel}
            className={styles.button}
            onClick={handleCancel}
          />
          <Button
            title={t('common.add')}
            onClick={handleAddSubmit}
            className={styles.button}
          />
        </div>
      </div>
    </Modal>
  );
}

export default SelectedItemModal;
